(() => {
  if (window.TablissaRecommendations) return;

  const GENERIC_TAGS = new Set(['duvar tablosu','kanvas baskı','mdf tablo','modern duvar tablosu','poster']);
  const GENERIC_COLLECTIONS = new Set(['all','duvar-tablolari','frontpage']);
  let dataPromise;

  const norm = v => (v || '').toString().trim().toLocaleLowerCase('tr-TR');
  const money = n => new Intl.NumberFormat('tr-TR',{style:'currency',currency:'TRY',maximumFractionDigits:0}).format(Number(n||0));
  const meaningfulTags = p => (p.tags || []).map(norm).filter(t => t && !GENERIC_TAGS.has(t));
  const meaningfulCollections = p => (p.collections || []).map(norm).filter(c => c && !GENERIC_COLLECTIONS.has(c));

  function shared(a,b){
    const bs=new Set(b);
    return a.filter(x=>bs.has(x));
  }

  function scorePair(base,candidate){
    let score=0;
    const aTags=meaningfulTags(base), bTags=meaningfulTags(candidate);
    const tagShared=shared(aTags,bTags);
    score += tagShared.length * 10;

    const aCols=meaningfulCollections(base), bCols=meaningfulCollections(candidate);
    const colShared=shared(aCols,bCols);
    score += colShared.length * 6;

    if(base.type && candidate.type && norm(base.type)===norm(candidate.type)) score += 7;

    const ap=Number(base.priceNumber||0), bp=Number(candidate.priceNumber||0);
    if(ap&&bp){
      const diff=Math.abs(ap-bp);
      if(diff<=200) score+=4;
      else if(diff<=500) score+=3;
      else if(diff<=900) score+=1;
    }

    if(tagShared.some(t=>/botanik|manzara|soyut|geometrik|akdeniz|çiçek|cicek|bambu|zeytin/.test(t))) score += 5;
    return {score,tagShared,colShared};
  }

  function reasonFor(base,candidate,detail){
    const t=(detail.tagShared||[])[0];
    if(t){
      const pretty=(candidate.tags||[]).find(x=>norm(x)===t) || '';
      if(pretty) return pretty.replace(/ tablo$/i,'')+' uyumu';
    }
    if(base.type && candidate.type && norm(base.type)===norm(candidate.type)) return 'Aynı formda uyumlu eser';
    if((detail.colShared||[]).length) return 'Aynı koleksiyondan';
    return 'Tablissa seçimi';
  }

  function rank(baseProducts, products, excludedHandles=new Set(), limit=6){
    return products
      .filter(c=>!excludedHandles.has(c.handle))
      .map(c=>{
        let total=0,best=null;
        for(const b of baseProducts){
          const d=scorePair(b,c);
          total += d.score;
          if(!best || d.score>best.score) best=d;
        }
        if(baseProducts.length>1) total = total/baseProducts.length + ((best && best.score)||0)*0.45;
        return {p:c,score:total,detail:best||{score:0,tagShared:[],colShared:[]},base:baseProducts[0]};
      })
      .sort((a,b)=>b.score-a.score || a.p.title.localeCompare(b.p.title,'tr'))
      .slice(0,limit);
  }

  function esc(s){
    return String(s||'').replace(/[&<>"']/g, ch => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]));
  }

  function cardMarkup(item, compact=false){
    const p=item.p;
    const reason=reasonFor(item.base,p,item.detail);
    const action=compact
      ? '<button type="button" class="tl-rec-card__add" data-tl-add="'+esc(p.handle)+'">+ Ekle</button>'
      : '<a href="'+esc(p.url)+'" class="tl-rec-card__link">İncele →</a>';
    return '<article class="tl-rec-card '+(compact?'tl-rec-card--compact':'')+'">'+
      '<a class="tl-rec-card__media" href="'+esc(p.url)+'"><img src="'+esc(p.displayImage)+'" alt="'+esc(p.title)+'" loading="lazy"></a>'+
      '<div class="tl-rec-card__body">'+
        '<span class="tl-rec-card__reason">'+esc(reason)+'</span>'+
        '<a class="tl-rec-card__title" href="'+esc(p.url)+'">'+esc(p.title)+'</a>'+
        '<div class="tl-rec-card__bottom"><span>'+(p.price?esc(p.price)+"'den":'')+'</span>'+action+'</div>'+
      '</div></article>';
  }

  function loadData(){
    if(!dataPromise){
      dataPromise=fetch('/collections/all?view=smart-data',{credentials:'same-origin',cache:'force-cache'})
        .then(r=>{
          if(!r.ok) throw new Error('recommendation-data');
          return r.json();
        })
        .then(j=>(j.products||[]).filter(p=>p.handle&&p.displayImage));
    }
    return dataPromise;
  }

  async function renderProductContainer(el){
    try{
      const metaEl=el.querySelector('[data-tl-current-product]');
      const base=JSON.parse((metaEl&&metaEl.textContent)||'{}');
      if(!base.handle) return;
      const products=await loadData();
      const ranked=rank([base],products,new Set([base.handle]),4);
      const grid=el.querySelector('[data-tl-rec-grid]');
      if(!grid) return;
      grid.innerHTML=ranked.map(x=>cardMarkup(x,false)).join('');
      el.hidden=ranked.length===0;
    }catch(e){}
  }

  async function productJson(handle){
    const r=await fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'});
    if(!r.ok) throw new Error('product-json');
    return r.json();
  }

  function pickVariant(pj, cart){
    const first=cart.items && cart.items[0];
    const desired={};
    ((first&&first.options_with_values)||[]).forEach(o=>desired[norm(o.name)]=o.value);
    const optionNames=(pj.options||[]).map(o=>norm(typeof o==='string'?o:o.name));
    const variants=(pj.variants||[]).filter(v=>v.available);
    if(!variants.length) return null;

    const materialIndex=optionNames.findIndex(n=>/baskı|baski|material/.test(n));
    const sizeIndex=optionNames.findIndex(n=>/boyut|ölçü|olcu|size/.test(n));
    const wantedMaterial=(Object.entries(desired).find(([k])=>/baskı|baski|material/.test(k))||[])[1];
    const wantedSize=(Object.entries(desired).find(([k])=>/boyut|ölçü|olcu|size/.test(k))||[])[1];

    const exact=variants.find(v=>
      (materialIndex<0 || !wantedMaterial || norm((v.options||[])[materialIndex])===norm(wantedMaterial)) &&
      (sizeIndex<0 || !wantedSize || norm((v.options||[])[sizeIndex])===norm(wantedSize))
    );
    if(exact) return exact;

    const sameMaterial=variants
      .filter(v=>materialIndex<0 || !wantedMaterial || norm((v.options||[])[materialIndex])===norm(wantedMaterial))
      .sort((a,b)=>Number(a.price)-Number(b.price))[0];

    return sameMaterial||variants.sort((a,b)=>Number(a.price)-Number(b.price))[0];
  }

  async function addRecommended(handle,button){
    if(button.dataset.loading==='1') return;
    button.dataset.loading='1';
    button.textContent='Ekleniyor…';
    try{
      const cartPromise=fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(r=>r.json());
      const results=await Promise.all([cartPromise,productJson(handle)]);
      const cart=results[0], pj=results[1];
      const variant=pickVariant(pj,cart);
      if(!variant) throw new Error('variant');

      const add=await fetch('/cart/add.js',{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:variant.id,quantity:1}]})
      });
      if(!add.ok) throw new Error('add');
      button.textContent='Eklendi ✓';
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }catch(e){
      button.textContent='Ürünü gör';
      button.onclick=()=>location.href='/products/'+handle;
    }finally{
      setTimeout(()=>{button.dataset.loading='0';},1200);
    }
  }

  async function renderCart(){
    const staleHosts=[...document.querySelectorAll('#tablissa-cart-recommendations')];
    staleHosts.slice(1).forEach(el=>el.remove());

    const reward=document.getElementById('tablissa-cart-reward');
    if(!reward) return;

    const inDrawer=!!reward.closest('#cart-drawer');
    if(inDrawer && window.matchMedia('(max-width: 749px)').matches){
      staleHosts.forEach(el=>el.remove());
      return;
    }

    let host=document.getElementById('tablissa-cart-recommendations');
    if(!host){
      host=document.createElement('div');
      host.id='tablissa-cart-recommendations';
      reward.insertAdjacentElement('afterend',host);
    }

    try{
      const results=await Promise.all([
        fetch('/cart.js',{credentials:'same-origin',cache:'no-store'}).then(r=>r.json()),
        loadData()
      ]);
      const cart=results[0], products=results[1];

      if(!cart.items || !cart.items.length){
        host.remove();
        return;
      }

      const map=new Map(products.map(p=>[p.handle,p]));
      const bases=cart.items.map(i=>map.get(i.handle)).filter(Boolean);
      if(!bases.length){
        host.hidden=true;
        return;
      }

      const excluded=new Set(cart.items.map(i=>i.handle));
      const ranked=rank(bases,products,excluded,3);
      const remain=Math.max(0,1390-(cart.total_price/100));
      const signature=cart.total_price+'|'+cart.items.map(i=>i.handle+':'+i.quantity+':'+i.variant_id).join(',');
      if(host.dataset.signature===signature) return;
      host.dataset.signature=signature;

      host.className='tl-cart-recs';
      host.innerHTML=
        '<div class="tl-cart-recs__head">'+
          '<div><span>UYUMLU EK SEÇİMLER</span><strong>'+(remain>0?'Ücretsiz kargoya yaklaşırken bunlara da bakın':'Bu seçimlerle birlikte iyi gider')+'</strong></div>'+
          (remain>0?'<b>'+money(remain)+' kaldı</b>':'')+
        '</div>'+
        '<div class="tl-cart-recs__grid">'+ranked.map(x=>cardMarkup(x,true)).join('')+'</div>';

      host.querySelectorAll('[data-tl-add]').forEach(btn=>{
        btn.addEventListener('click',()=>addRecommended(btn.dataset.tlAdd,btn));
      });
    }catch(e){}
  }

  function init(){
    document.querySelectorAll('[data-tl-recommendations]').forEach(renderProductContainer);
    renderCart();

    let queued=false;
    new MutationObserver(()=>{
      if(queued) return;
      queued=true;
      setTimeout(()=>{
        queued=false;
        renderCart();
      },180);
    }).observe(document.body,{childList:true,subtree:true});

    document.addEventListener('cart:updated',()=>setTimeout(renderCart,120));
  }

  window.TablissaRecommendations={renderCart,rank};

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }
})();